import { Component, forwardRef, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, FormControl, FormGroup} from '@angular/forms';
import { AbstractControl } from '@angular/forms/src/model';
import { UtilService } from '../../../util/util.service';
declare var $: any;
declare var moment: any;

const noop = () => {
};

@Component({
  selector: 'ats-data-picker',
  templateUrl: './data-picker.component.html',
  styleUrls: ['./data-picker.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DataPickerComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => DataPickerComponent), multi: true }
  ]
})
export class DataPickerComponent implements ControlValueAccessor, Validator, OnInit {

  @Input() label: string;
  @Input() nomeCampo: string;
  @Input() locale: string = 'pt-br';
  @Input() options: any = null;
  @Input() campoObrigatorio: boolean = false;
  @Input() somenteDataMenorAtual: boolean = false;
  @Input() formControlName: string;
  @Input() formGroup: FormGroup;
  @Input() value: any;

  @Output()
  change: EventEmitter<any> = new EventEmitter<any>();


  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  private idComponent: number;
  public classDataPicker : string;
  public classError : string;
  private inputDataPicker : string;
  private errorDataPicker : string;

  constructor() { }

  ngOnInit() {
    var self = this;

    moment.locale('pt-br');

    if(this.options == null){
      this.options = {
        showClearDateBtn: false,
        selectionTxtFontSize: false,
        openSelectorOnInputClick: true,
        inline: false,
        componentDisabled: false
      };
    }

    this.idComponent = Math.floor(Math.random() * 600) + 1;
    this.classDataPicker = 'data-picker-' + this.idComponent;
    this.classError = 'error-data-picker-' + this.idComponent;
    this.inputDataPicker = 'my-date-picker.' + this.classDataPicker + ' input';
    this.errorDataPicker = 'div.' + this.classError;

    if(!UtilService.empty(this.formGroup) && !UtilService.empty(this.value) && this.formGroup[this.formControlName] != undefined){
      this.value = this.formGroup[this.formControlName];
    }else{
      if(!UtilService.empty(this.value)){
        this.formGroup[this.formControlName] = this.value;
      }
    }

    $('body').on('blur', this.inputDataPicker, function(e){
      var input = this;
      var data = $.trim($(this).val());

      if(self.campoObrigatorio && $.ats._empty(data)){
        $(input).removeClass('ng-valid').addClass('ng-invalid');
        $(self.errorDataPicker).html('Campo Obrigatório');
        $(self.errorDataPicker).show();
      }else{
        if($.ats._empty(data) || $.ats._isValidDate(data)){
          if(self.somenteDataMenorAtual && new moment(data,'DD/MM/YYYY').isSameOrAfter(new moment(Date.now()))){
            $(input).removeClass('ng-valid').addClass('ng-invalid');
            $(self.errorDataPicker).html('Data não pode ser superior a data atual');
            $(self.errorDataPicker).show();
          }else{
            $(self.errorDataPicker).hide();
            $(input).removeClass('ng-invalid').addClass('ng-valid');
          }
        }else{
          $(input).removeClass('ng-valid').addClass('ng-invalid');
          $(self.errorDataPicker).html('Data inválida');
          $(self.errorDataPicker).show();
        }
      }

    });

    $(document).ready(function () {
      $(self.inputDataPicker).mask('99/99/9999');
    });

  }
    public writeValue(value: any) {
      this.value = value;
      if(!UtilService.empty(this.formGroup) && !UtilService.empty(this.value) && this.formGroup[this.formControlName] != undefined){
        this.formGroup[this.formControlName] = this.value;
      }
      this.change.emit(this.value);
    }

    registerOnChange(fn: any) {
      this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
      this.onTouchedCallback = fn;
    }

    validaData(control: AbstractControl) : any{
      var data: string = '';
      var dataInput: string = $(this.inputDataPicker).val();
      var retorno : any = {};

      if((!$.ats._empty(dataInput)) || (!$.ats._empty(control.value) && Object.prototype.hasOwnProperty.call(control.value, this.formControlName) && !$.ats._empty(control.value[this.formControlName]))){

        if(!$.ats._empty(dataInput)){
          data = dataInput;
        }else{
          if(!$.ats._empty(control.value) && Object.prototype.hasOwnProperty.call(control.value, this.formControlName) && !$.ats._empty(control.value[this.formControlName]) && !$.ats._empty(control.value[this.formControlName]['date'])){
            data = new moment(control.value[this.formControlName]['date']['year']+'-'+control.value[this.formControlName]['date']['month'] + '-' + control.value[this.formControlName]['date']['day'], 'YYYY-MM-DD').format('DD/MM/YYYY');
          }else{
            if(control.value[this.formControlName] != undefined && control.value[this.formControlName]['date'] != undefined && control.value[this.formControlName]['date']['year'] != undefined){
              data = new moment(control.value['date']['year'] + '-' + control.value['date']['month'] + '-' + control.value['date']['day'],'YYYY-MM-DD').format('DD/MM/YYYY');
            }else{
              data = new moment(control.value[this.formControlName],'YYYY-MM-DD').format('DD/MM/YYYY');
            }
          }
        }

        if(this.campoObrigatorio && $.ats._empty(data)){
          retorno['validateDataObrigatorio'] = {};
          retorno['validateDataObrigatorio']['valid'] = false;
        }else{
          if($.ats._empty(data) || $.ats._isValidDate(data)){
            if(this.somenteDataMenorAtual && new moment(data,'DD/MM/YYYY').isSameOrAfter(new moment(Date.now()))){
              retorno['validateDataSuperiorDataAtual'] = {};
              retorno['validateDataSuperiorDataAtual']['valid'] = false;
            }else{
              retorno = null;
            }
          }else{
            retorno['validateDataInvalida'] = {};
            retorno['validateDataInvalida']['valid'] = false;
          }
        }
      }else{
        retorno = null;
      }

      return retorno;
    }

    public validate(control: AbstractControl) {
      return this.validaData(control);
    }

    onChangeDate(event){
      if((!UtilService.empty(event)) && (event.date != undefined)){
        if(!(event.date.year === 0 && event.date.month === 0 && event.date.day === 0)){
          this.change.emit(event.date);
        }else{
          this.change.emit(null);
        }
      }else{
        this.change.emit(null);
      }
    }

    onChangeData(event){
      if(UtilService.empty(event.target.value)){
        this.change.emit(UtilService.parseDatePicker(new moment(event.target.value, 'DD/MM/YYYY').toDate()));
      }else{
        this.change.emit(null);
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/componentes/data-picker/data-picker.component.ts